import React, { FC } from 'react';
import { back, pathToAction } from 'redux-first-router';
import styled from 'styled-components';
import { history } from 'redux-first-router';

import { navigateOut } from '../../../utils';
import { AutomationText } from '../Automation';
import { FontIcon } from '../FontIcon';
import routesMap from '../../../routesMap';

const Back = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--sys-color--on-surface);
  text-decoration: none;
  width: 24px;
  height: 24px;
`;

interface BackLinkProps {
  directLink?: boolean;
  backNavigate?: () => void;
  icon?: string;
}

export const BackLink: FC<BackLinkProps> = ({
  directLink,
  backNavigate,
  icon = 'arrow_back',
}) => {
  const onNavigate = (event: any) => {
    event.preventDefault();
    if (typeof directLink !== 'undefined') {
      navigateOut();
      return;
    }

    const action = pathToAction(history().location.pathname, routesMap);
    if (backNavigate) {
      backNavigate();
      return;
    }

    // if the page we are trying to exit is the first page we entered we should exit the gallery
    // basically you can go out only the way you came in
    if ((window as any).__firstPage === action.type) {
      navigateOut();
      return;
    }

    back();
  };

  return (
    <Back className="back-text-v2" aria-label="back-button" id="back-button" onClick={onNavigate}>
      <FontIcon name={icon} size={24} />
      <AutomationText/>
    </Back>
  );
}

